import SiteConfig from "../Config/SiteConfig";
import {UserCustomFormSchema} from "./CustomSchemas/UserCustomListSchema";
import {ProfileCustomFormSchema} from "./CustomSchemas/UserProfilesCustomSchema";
import {UserIntegrationCustomFormSchema} from "./CustomSchemas/UserIntegrationCustomSchema";
import {TenantCustomFormSchema} from "./CustomSchemas/TenantCustomSchema";


export default class FormSchemaConfig {


    static REGISTERED_SCHEMA = {};

    static SCHEMA_CUSTOMIZATION = [
        UserCustomFormSchema, ProfileCustomFormSchema, UserIntegrationCustomFormSchema, TenantCustomFormSchema,
        //, MenuCustomFormSchema
        ];

    async getSchema(name, params) {

        if (FormSchemaConfig.REGISTERED_SCHEMA[name]) {
            return FormSchemaConfig.REGISTERED_SCHEMA[name];
        }

        const siteConfigService = new SiteConfig();
        const siteConfig = await siteConfigService.getSiteConfig();
        const schema = siteConfig.formSchema[name] || {name};

        FormSchemaConfig.SCHEMA_CUSTOMIZATION.forEach(custom => {
            custom(name, schema, params);
        });

        FormSchemaConfig.REGISTERED_SCHEMA[name] = schema;
        console.log('SCHEMA NEW FORM REGISTERED', schema);
        return schema;
    }


    async getFormSchemaByName(name,params) {
        return this.getSchema(name,params);
    }

}
